<template>
    <div class="o-sms-modal-standard-fail">
        <img
            src="../../../assets/images/icons/fail.svg"
            class="sms-modal-standard-fail-image"
        >
        <span class="sms-modal-standard-fail-message" v-html="messageText" />
    </div>
</template>

<script>
export default {
    name: "OSmsModalStandardFail",
    props: {
        message: {
            type: String,
            default: ''
        }
    },
    computed: {
        messageText() {
            if (this.message) {
                return this.message;
            }

            return 'Message wasn\'t sent.<br>SMS service is not available.<br>Please try again later';
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>